// extracted by mini-css-extract-plugin
module.exports = {"no-result":"NoResults-module__no-result___vApC6"};